module.exports = __webpack_public_path__ + "static/media/honda-pin.65c09e7e.svg";